
import { mapGetters } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import LoleBtn from '~/components/buttons/lole-btn'
import LoleH1 from '~/components/text/lole-h1'
import LoleInput from '~/components/form/input/lole-input'
import LoleInputPassword from '~/components/form/input/lole-input-password'
import LoleP from '~/components/text/lole-p'
import LoleLink from '~/components/link/lole-link'
import LoleFormError from '~/components/form/error/lole-error-form'

export default {
  name: 'LoleSignin',
  components: {
    LoleBtn,
    LoleH1,
    LoleInput,
    LoleInputPassword,
    LoleP,
    LoleLink,
    LoleFormError,
  },
  props: {
    wording: {
      type: Object,
      required: true,
    },
    wordingErrors: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    formSignIn: { email: '', password: '' },
    submitted: false,
    errors: [],
    loading: false,
    showPassword: false,
  }),
  validations: {
    formSignIn: {
      email: { required, email },
      password: { required },
    },
  },
  computed: {
    ...mapGetters({
      vxCustomer: 'customer/getCustomer',
    }),
  },
  methods: {
    async login() {
      this.$v.$touch()
      this.submitted = true
      this.errors = []
      if (!this.$v.$invalid) {
        this.loading = true
        try {
          await this.$store.dispatch('customer/login', this.formSignIn)
          this.$router.push(this.localePath('/account'))
        } catch (e) {
          this.errors.push({ code: 'SIGNIN-FAIL' })
        }
        this.loading = false
      }

      if (this.vxCustomer) {
        try {
          this.$store.dispatch('stamped/init', this.vxCustomer)
        } catch (error) {
          console.log('ERROR STAMPED INIT at login')
        }
      }
    },
  },
}
